import {createAsyncThunk} from '@reduxjs/toolkit';
import type {CancelSurveyReasonIDs, PauseIntervals} from '@Libraries/cancel-subscription-library';
import type {ChangePlanArgs, ChangePlanCost, ChangePlanCostArgs, ChangePlanSuccessResponse} from '@Panels/change-plan-modal/change-plan-modal.types';
import type {PostCancellationFeedbackArgs, SupportRequestArgs} from '@Panels/cancel-subscription-panel/cancel-subscription-panel.types';

const SUPPORT_ATTACHMENT_FIELD = 'attachments[]';

export const initCancelSubscriptionPanel = createAsyncThunk('initCancelSubscriptionPanel', async () => {
  return window.PMW.readLocal('premium/cancelSubscriptionDialog');
});

export const cancelSubscription = createAsyncThunk('cancelSubscription', async ({reason, comments}: {reason: CancelSurveyReasonIDs; comments: string}) => {
  return window.PMW.writeLocal('premium/cancelSubscription', {
    reason: reason,
    comments: comments,
  });
});

export const pauseSubscription = createAsyncThunk('pauseSubscription', async ({interval}: {interval: PauseIntervals}) => {
  return window.PMW.writeLocal('premium/pauseSubscription', {interval: interval});
});

export const applyRetentionDiscount = createAsyncThunk<{redirectURL: string}>('applyRetentionDiscount', async () => {
  const response: unknown = await window.PMW.writeLocal('premium/applyRetentionDiscount');
  return response as {redirectURL: string};
});

export const getCheaperPlanChangeCost = createAsyncThunk<ChangePlanCost, ChangePlanCostArgs>('getCheaperPlanChangeCost', async (data: ChangePlanCostArgs) => {
  const response: unknown = await window.PMW.readLocal('premium/getChangePlanCost', data);
  return response as ChangePlanCost;
});

export const switchToCheaperPlan = createAsyncThunk<ChangePlanSuccessResponse, ChangePlanArgs>('switchToCheaperPlan', async (data: ChangePlanArgs) => {
  const response: unknown = await window.PMW.writeLocal('premium/changeSubscriptionPlan', data);
  return response as ChangePlanSuccessResponse;
});

export const submitCancellationSupportRequest = createAsyncThunk('submitCancellationSupportRequest', async ({summary, description, files}: SupportRequestArgs) => {
  const formData = new FormData();
  formData.append('summary', summary);
  formData.append('description', description);
  files.forEach((file) => {
    formData.append(SUPPORT_ATTACHMENT_FIELD, file);
  });

  await window.PMW.writeLocal('premium/submitCancellationSupportRequest', formData, 'json', {
    cache: false,
    processData: false,
    contentType: false,
  });
});

export const submitPostCancellationFeedback = createAsyncThunk('submitPostCancellationFeedback', async ({feedback}: PostCancellationFeedbackArgs) => {
  await window.PMW.writeLocal('premium/submitPostCancellationFeedback', {feedback});
});
